<template>
    <div>
        <section id="team" class="team section">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <div class="section-title align-center gray-bg">
                            <span>Team</span>
                            <h2 class="wow fadeInUp" data-wow-delay=".4s">Our Experienced Team</h2>
                            <p class="wow fadeInUp" data-wow-delay=".6s">The brains behind Tribinnov Africa</p>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-6 col-md-6 col-12" v-for="member in members" :key="member.id">
                        <div class="single-team wow fadeInUp" data-wow-delay=".4s">
                            <div class="row">
                                <div class="col-lg-5 col-12">
                                    <div class="image my-5">
                                        <img :src="member.image" :alt="member.name">
                                    </div>

                                </div>
                                <div class="col-lg-7 col-12">
                                    <div class="info-head">

                                        <div class="info-box">
                                            <span class="designation">{{member.role}}</span>
                                            <h4 class="name">{{member.name}}</h4>
                                            <p>{{member.description}}</p>
                                        </div>

                                        <!-- 
                                        <ul class="social">
                                            <li><a href="javascript:void(0)"><i class="lni lni-facebook-filled"></i></a>
                                            </li>
                                            <li><a href="javascript:void(0)"><i
                                                        class="lni lni-twitter-original"></i></a></li>
                                            <li><a href="javascript:void(0)"><i
                                                        class="lni lni-linkedin-original"></i></a></li>
                                            <li><a href="javascript:void(0)"><i
                                                        class="lni lni-behance-original"></i></a></li>
                                        </ul> -->

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </section>


    </div>
</template>

<script>
    import { team } from "../../json/team.js"
    
    export default {
        name: 'Team',
        data() {
            return {
                members: team
            }
        },
        metaInfo: {
            title: "Tribinnov Africa - Our Team",
            meta: [
                {
                    name: "description", content: "The brains behind Tribinnov Africa"
                },
                { name: "keywords", content: "investment, finance, tribinnov, tribinnov africa, tribe of innovation, tribe, africa, nigeria, funding, crowdfunding, fundraiser" }
            ]
        }
    }
</script>
